import { AxiosError, AxiosInstance, AxiosRequestConfig } from 'axios';

import getHeaders from '../http-header';

const requestHandler = (request: AxiosRequestConfig): any => {
    if (request) {
        const isFormData =
            typeof FormData !== 'undefined' && request.data instanceof FormData;
        const headers = { ...getHeaders(), ...request.headers };
        if (isFormData) {
            delete headers['Content-Type'];
            delete headers['content-type'];
        }
        request.headers = headers;
    }
    return request;
};

const requestErrorHandler = (error: AxiosError): Promise<AxiosError> => Promise.reject(error);

export function requestInterceptor(axiosInstance: AxiosInstance): AxiosInstance {
    axiosInstance.interceptors.request.use(requestHandler, requestErrorHandler);
    return axiosInstance;
}
